// Mocked service; replace with real API call
export const getPayments = async () => {
    return [
      {
        studentName: 'John Doe',
        amount: '₹1500',
        date: '2025-05-01',
        method: 'UPI',
        transactionId: 'TXN123456',
        status: 'Success',
      },
      {
        studentName: 'Jane Smith',
        amount: '₹2000',
        date: '2025-04-28',
        method: 'Card',
        transactionId: 'TXN123789',
        status: 'Success',
      },
    ];
  };
  